import React from 'react';
import Menu from '@mui/material/Menu';
import { reset } from '../../../store/actions/CommonAction';
import { fetchAndSelect } from '../../../store/actions/RealmAction';
import { useDispatch, useSelector } from 'react-redux';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { PersonAdd, Star, StarOutline } from '@mui/icons-material';
import { getPXLDashboardRoute } from '../../../router/routes/pxl/factory/general';
import { useHistory } from '../../utils/reactRouterCompatibility';
import { useTranslation } from 'react-i18next';
import { getArtistWizardRoute } from '../../../router/routes/artist/factory/wizard';

const RealmMenu = ({ anchorEl, setAnchorEl }) => {
	const dispatch = useDispatch();
	const open = Boolean(anchorEl);
	const history = useHistory();
	const { t } = useTranslation();

	const list = useSelector(state => state.realm.realms);
	const selected = useSelector(state => state.realm.selected);

	const handleClose = () => {
		setAnchorEl(null);
	};

	const realmChangeHandler = (v) => {
		if (!v) return;
		const filtered = list.filter((f) => f.Realm__ === v);
		dispatch(reset());

		if (filtered.length > 0) {
			dispatch(fetchAndSelect(filtered[0].Realm__));
			handleClose();
			history.push(getPXLDashboardRoute());
		} else {
			console.log('Trying to select unknown realm value : ' + v + ' ');
		}
	};

	return (
		<Menu
			id="menu-appbar"
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			slotProps={{
				paper: {
					style: {
						maxHeight: '500px',
					},
				},
			}}
			open={open}
			onClose={handleClose}
		>
			{list.map(realm => (
				<MenuItem
					key={realm.Realm__}
					selected={selected?.Realm__ === realm.Realm__}
					onClick={() => realmChangeHandler(realm.Realm__)}
				>
					<ListItemIcon>
						{selected?.Realm__ !== realm.Realm__ && <StarOutline fontSize="small" />}
						{selected?.Realm__ === realm.Realm__ && <Star color="primary" fontSize="small" />}
					</ListItemIcon>
					<ListItemText primary={realm.Name} />
				</MenuItem>
			))}
			<MenuItem onClick={() => {
				history.push(getArtistWizardRoute());
				handleClose();
			}}>
				<ListItemIcon>
					<PersonAdd />
				</ListItemIcon>
				<ListItemText primary={t('menu_artist_wizard')} />
			</MenuItem>
		</Menu>
	);
};

export default RealmMenu;
